import { useEffect } from "react";
import { chatSupportPath } from "./general-config";

const StickyChatV2 = () => {
  useEffect(() => {
    const script = document.createElement("script");
    const widgetUrl = chatSupportPath();
    script.src = widgetUrl;
    script.async = true;
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return null;
};

export default StickyChatV2;